import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    step1:true,
    step2:false,
    step3:false,
    step4:false,
    step5:false,
    step6:false,
    step7:false,
};

// console.log("Redux stepperItemStatus:", initialState.stepperItemStatus);

const stepSlice = createSlice({
    name: 'step',
    initialState,
    reducers: {
        handleStep(state, action) {
           const {stepNumber, value} = action.payload;
        //    console.log("stepNumber", stepNumber);
        //    console.log("Value", value);
           
            state[`step${stepNumber}`]= value;
            // state.stepperItemStatus = value ? 'completed' : 'active'
            // console.log("state", state);
           
        },

    },
});

export const { handleStep } = stepSlice.actions;

export default stepSlice.reducer;
